import { render, staticRenderFns } from "./ManageReservations.vue?vue&type=template&id=04863037&scoped=true"
import script from "./ManageReservations.vue?vue&type=script&lang=js"
export * from "./ManageReservations.vue?vue&type=script&lang=js"
import style0 from "./ManageReservations.vue?vue&type=style&index=0&id=04863037&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04863037",
  null
  
)

export default component.exports